import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Icon, Spacer } from '@ontruck/orc';

const StyledContainer = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${(props) => props.w};
  color: #fff;
  text-decoration: none;
  height: 100%;
  font-size: 1.4rem;
  padding-right: 1.6rem;
  padding-left: 1.6rem;
  text-transform: uppercase;
  line-height: normal;
  background-color: var(--primary);
  &:hover {
    cursor: pointer;
    background-color: var(--primary900);
  }
`;

export const BackButton = ({ to, text }) => {
  return (
    <StyledContainer to={to} w="130px">
      <Spacer mRight="XS">
        <Icon glyph="previous" size="2rem" color="white" />
      </Spacer>
      {text}
    </StyledContainer>
  );
};
export const CloseButton = ({ to }) => {
  return (
    <StyledContainer to={to} w="48px">
      <Spacer>
        <Icon glyph="close" size="2rem" color="white" />
      </Spacer>
    </StyledContainer>
  );
};

export default BackButton;
